import { useRef, useEffect, useState } from "react";
import { Card, CardHeader, CardTitle, CardContent, CardDescription, CardAction } from '../../shadcnComponents/ui/card';
import { Button } from '../../shadcnComponents/ui/button';
import { XMarkIcon } from '@heroicons/react/24/solid';

export function MoveMenu(props) {

    // SubfoldersTemp are always accessible by all functions but don't update DOM state to prevent displaying subfolders of selected directories
    // This is why useState is needed
    const subFoldersTemp = useRef([])
    const [subFoldersToAvoid, setSubfoldersToAvoid] = useState([])

    function getChildrenDirectories(dirId) {
        if (props.fileMap[dirId] && props.fileMap[dirId].childrenIds.length > 0) {
            props.fileMap[dirId].childrenIds.map(each => {
                if (props.fileMap[each] && props.fileMap[each].isDir) {
                    subFoldersTemp.current = [...subFoldersTemp.current, each]
                    getChildrenDirectories(each)
                    return;
                } else {
                    return;
                }
            })
        } else {
            return;
        }
    }

    useEffect(() => {
        if (props.fileMap && props.selectedFiles) {
            subFoldersTemp.current = [props.currentLocation.id]
            props.selectedFiles.map(each => {
                if (props.fileMap[each].isDir) {
                    subFoldersTemp.current = [...subFoldersTemp.current, each]
                    getChildrenDirectories(each)
                }
            })
        }
        setSubfoldersToAvoid(subFoldersTemp.current)
    }, [props.currentLocation, props.selectedFiles])

    return (
        <div id='move-menu' className="hidden fixed z-10 w-screen h-screen top-0 left-0 bg-secondary-background flex items-center justify-center">
            <Card className='w-[40rem]'>
                <CardHeader>
                    {props.message ?
                        <CardTitle>{props.message}</CardTitle>
                        :
                        <CardTitle>{props.selectedFiles.length + ' ' + `${props.selectedFiles.length == 1 ? 'στοιχείο έχει επιλεγεί για μετακίνηση' : 'στοιχεία έχουν επιλεγεί για μετακίνηση'}`}</CardTitle>
                    }
                    <CardDescription>
                        Επιλέξτε προορισμό
                    </CardDescription>
                    <CardAction>
                        <Button onClick={() => { document.getElementById('move-menu').classList.add('hidden'); }} variant="link">
                            <XMarkIcon className='size-6' />
                        </Button>
                    </CardAction>
                </CardHeader>
                <CardContent className="flex flex-col h-full overflow-auto gap-1">
                    {props.fileMap && Object.values(props.fileMap)
                        .filter((item) => { if (item && item.isDir && !subFoldersToAvoid.includes(item.id)) { return item } }) // Only include items where isDir is true
                        .map(item => (
                            <Button variant={'ghost'} className='flex flex-row items-center justify-start font-normal'
                                key={item.id}
                                onClick={() => props.handleClick(item)}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" height={20} width={20} viewBox="0 0 512 512" className="text-accent-foreground">
                                    <path fill="currentColor" fillOpacity="0.8" strokeLinejoin="round" strokeLinecap="round" d="M64 400l384 0c8.8 0 16-7.2 16-16l0-240c0-8.8-7.2-16-16-16l-149.3 0c-17.3 0-34.2-5.6-48-16L212.3 83.2c-2.8-2.1-6.1-3.2-9.6-3.2L64 80c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16zm384 48L64 448c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l138.7 0c13.8 0 27.3 4.5 38.4 12.8l38.4 28.8c5.5 4.2 12.3 6.4 19.2 6.4L448 80c35.3 0 64 28.7 64 64l0 240c0 35.3-28.7 64-64 64z" />
                                </svg>
                                {item.name}
                            </Button>
                        ))
                    }
                </CardContent>
            </Card>
        </div>
    )
}

export default MoveMenu